{
  "header": "Your application was not submitted.",
  "greeting": "We cannot proceed with your application at this time. Please check your email for more information about your application status.",
  "nextSteps": "To change your payment method and complete your booking, contact your agent.",
  "thanks": "We apologize for any inconvenience."
}
